export const adyenClientKey = process.env.REACT_APP_ADYEN_CLIENT_KEY;
export const adyenApiKey = process.env.REACT_APP_ADYEN_API_KEY;
export const adyenEnvironment = process.env.REACT_APP_ADYEN_ENVIRONMENT;
export const measurementIdGA = process.env.REACT_APP_GA_MEASUREMENT_ID;
